import NewCaseStudyHero from './NewCaseStudyHero';
import Cases from './Cases';

const NewCaseStudy = () => {
  
  return (
    <div>
      <NewCaseStudyHero/>
      <Cases/>
    </div>
  )
}

export default NewCaseStudy